import { FileStatus } from '@src/components/FilePreview/types'
import { lang } from '@src/lang'

export const GITHUB_URL = 'https://github.com/kuksprog/clean_coast/'
export const CONCURRENCY_LIMIT = 5

export const colorByStatus = {
    [FileStatus.COMPLETED]: 'green',
    [FileStatus.IN_PROGRESS]: 'gray',
    [FileStatus.WAITING]: 'gray',
    [FileStatus.ERROR]: 'red',
    [FileStatus.CANCELED]: 'orange',
}

export const labelByStatus = {
    [FileStatus.COMPLETED]: lang.completed,
    [FileStatus.IN_PROGRESS]: lang.inProgress,
    [FileStatus.WAITING]: lang.waiting,
    [FileStatus.ERROR]: lang.error,
    [FileStatus.CANCELED]: lang.cancel,
}

export const progressValueByStatus = {
    [FileStatus.COMPLETED]: 100,
    [FileStatus.IN_PROGRESS]: null,
    [FileStatus.WAITING]: 0,
    [FileStatus.ERROR]: 100,
    [FileStatus.CANCELED]: 0,
}
